import axios from 'axios';
import {APIUrl} from '../constants/ApplicationConstants.js';
import {SendNetCodeResults, VerifyNetCodeResults} from '../constants/IDVerificationConstants.js';
import CallBackActions from '../actions/DigitalConsentApiCallBackActions.js';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';
import ErrorHandler from '../core/ErrorHandler.js';

module.exports = {
    generateSingleNetCode: function(productId, mobileNumber, applicationId) {
        const url = APIUrl.BASE_PRODUCTS_URL +
            productId +
            APIUrl.APPLICATION +
            applicationId +
            APIUrl.NETCODE_BASE +
            APIUrl.GENERATE_SINGLE +
            mobileNumber;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                CallBackActions.receiveSendNetCodeResult(response.data);
            })
            .catch((error) => {
                ErrorHandler.logError(Error('Generating single netcode', error));
                CallBackActions.receiveSendNetCodeResult({generateSmsCodeResult: SendNetCodeResults.ServerError});
            });
    },

    generateMultipleNetCodes: function(productId, mobileNumbers, applicationId) {
        const url = APIUrl.BASE_PRODUCTS_URL +
            productId +
            APIUrl.APPLICATION +
            applicationId +
            APIUrl.NETCODE_BASE +
            mobileNumbers +
            APIUrl.GENERATE_MULTIPLE;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                CallBackActions.receiveSendNetCodeResult(response.data);
            })
            .catch((error) => {
                ErrorHandler.logError(Error('Generating multiple netcodes', error));
                CallBackActions.receiveSendNetCodeResult({generateSmsCodeResult: SendNetCodeResults.ServerError});
            });
    },

    resendMultipleNetCodes: function(productId, mobileNumbers, applicationId) {
        const url = APIUrl.BASE_PRODUCTS_URL +
            productId +
            APIUrl.APPLICATION +
            applicationId +
            APIUrl.NETCODE_BASE +
            mobileNumbers +
            APIUrl.GENERATE_MULTIPLE;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                CallBackActions.receiveResendNetCodeResult(response.data);
            })
            .catch((error) => {
                ErrorHandler.logError(Error('Resending multiple netcodes', error));
                CallBackActions.receiveResendNetCodeResult({generateSmsCodeResult: SendNetCodeResults.ServerError});
            });
    },
    verifySingleNetCode: function(productId, mobileNumber, netCode, applicationId) {
        const url = APIUrl.BASE_PRODUCTS_URL +
            productId +
            APIUrl.APPLICATION +
            applicationId +
            APIUrl.NETCODE_BASE +
            APIUrl.VERIFY_SINGLE_1 +
            mobileNumber +
            APIUrl.VERIFY_SINGLE_2 +
            netCode;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                CallBackActions.receiveVerifyNetCodeResult(response.data);
            })
            .catch((error) => {
                ErrorHandler.logError(Error('Verifying single netcode', error));
                CallBackActions
                    .receiveVerifyNetCodeResult({
                        verifyNetCodeResult: {
                            mobileNumber: mobileNumber,
                            verificationResult: SendNetCodeResults.ServerError
                        }
                    });
            });
    },
    verifyMultipleNetCodes: function(productId, mobileNumbers, netCodes, applicationId) {
        const url = APIUrl.BASE_PRODUCTS_URL +
            productId +
            APIUrl.APPLICATION +
            applicationId +
            APIUrl.NETCODE_BASE +
            mobileNumbers +
            '/' +
            netCodes +
            APIUrl.VERIFY_MULTIPLE;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                CallBackActions.receiveVerifyMultipleNetCodeResult(response.data);
            })
            .catch((error) => {
                ErrorHandler.logError(Error('Verifying multiple netcodes', error));
                let errResponse = [];

                for (var i = 0; i < mobileNumbers.length; i++) {
                    errResponse.push({
                        mobileNumber: mobileNumbers[i],
                        verificationResponse: VerifyNetCodeResults.ServerError
                    });
                }
                CallBackActions.receiveVerifyMultipleNetCodeResult({
                    verifyNetCodeResults:errResponse
                });
            });
    },
    getUserIp:function() {
        axios.get(APIUrl.COMMON_GET_CLIENT_IP)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                CallBackActions.receiveClientIpAddress(response.data);
            })
            .catch((error) => {
                CallBackActions.receiveClientIpAddress('Unable to retreive client ip address');
                ErrorHandler.logError(Error('Unable to retreive client ip address', error));
            });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/NetCodeAPI.js